import React from 'react'
import './Loading.css'

const Loading = ({classe}) => {

 
  
  return (

    <dialog id='Loading'>
        <div className={`lds-spinner ${classe}`}>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
    </dialog>
  )
}

export default Loading